"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapTireSetToVehicleAccessory = exports.mapAccessoryToVehicleAccessory = exports.mapTireSetToCommonAccessory = exports.mapAccessoryToCommonAccessory = exports.mapVehicleAccessoryInputToPimCommonInput = void 0;
const interfaces_1 = require("../../../../interfaces");
const enums_1 = require("../../../../enums");
const mapVehicleAccessoryInputToPimCommonInput = (input) => {
    var _a, _b, _c, _d;
    return {
        accessoryType: input === null || input === void 0 ? void 0 : input.accessoryType,
        description: input === null || input === void 0 ? void 0 : input.description,
        id: ((_a = input === null || input === void 0 ? void 0 : input.reference) === null || _a === void 0 ? void 0 : _a.pimId) || ((_b = input) === null || _b === void 0 ? void 0 : _b.id),
        isRecommended: input === null || input === void 0 ? void 0 : input.isRecommended,
        isVatExempt: input === null || input === void 0 ? void 0 : input.isVatExempt,
        name: input === null || input === void 0 ? void 0 : input.name,
        pimId: ((_c = input === null || input === void 0 ? void 0 : input.reference) === null || _c === void 0 ? void 0 : _c.pimId) || ((_d = input) === null || _d === void 0 ? void 0 : _d.id),
        price: input === null || input === void 0 ? void 0 : input.price,
        priceExcludingVat: input === null || input === void 0 ? void 0 : input.priceExcludingVat,
        vat: input === null || input === void 0 ? void 0 : input.vat,
        retailerMargin: input === null || input === void 0 ? void 0 : input.retailerMargin,
    };
};
exports.mapVehicleAccessoryInputToPimCommonInput = mapVehicleAccessoryInputToPimCommonInput;
const mapAccessoryToCommonAccessory = (accessory) => {
    return {
        accessoryType: enums_1.AccessoryType.ACCESSORY,
        description: accessory === null || accessory === void 0 ? void 0 : accessory.description,
        id: accessory === null || accessory === void 0 ? void 0 : accessory.id,
        isRecommended: accessory === null || accessory === void 0 ? void 0 : accessory.isRecommended,
        isVatExempt: accessory === null || accessory === void 0 ? void 0 : accessory.isVatExempt,
        name: accessory === null || accessory === void 0 ? void 0 : accessory.name,
        pimId: accessory === null || accessory === void 0 ? void 0 : accessory.id,
        price: accessory === null || accessory === void 0 ? void 0 : accessory.price,
        priceExcludingVat: accessory === null || accessory === void 0 ? void 0 : accessory.priceExcludingVat,
        vat: accessory === null || accessory === void 0 ? void 0 : accessory.vat,
        retailerMargin: accessory === null || accessory === void 0 ? void 0 : accessory.retailerMargin,
    };
};
exports.mapAccessoryToCommonAccessory = mapAccessoryToCommonAccessory;
const mapTireSetToCommonAccessory = (tireSet) => {
    return {
        accessoryType: enums_1.AccessoryType.TYRE,
        description: tireSet === null || tireSet === void 0 ? void 0 : tireSet.description,
        id: tireSet === null || tireSet === void 0 ? void 0 : tireSet.id,
        isRecommended: tireSet === null || tireSet === void 0 ? void 0 : tireSet.isRecommended,
        name: tireSet === null || tireSet === void 0 ? void 0 : tireSet.name,
        pimId: tireSet === null || tireSet === void 0 ? void 0 : tireSet.id,
        price: tireSet === null || tireSet === void 0 ? void 0 : tireSet.additionalPrice,
        priceExcludingVat: tireSet === null || tireSet === void 0 ? void 0 : tireSet.additionalPriceExcludingVat,
        vat: tireSet === null || tireSet === void 0 ? void 0 : tireSet.vat,
        retailerMargin: tireSet === null || tireSet === void 0 ? void 0 : tireSet.retailerMargin,
    };
};
exports.mapTireSetToCommonAccessory = mapTireSetToCommonAccessory;
const mapAccessoryToVehicleAccessory = (accessory, order) => {
    return {
        accessoryType: enums_1.AccessoryType.ACCESSORY,
        calculatedPriceBusiness: null,
        calculatedPricePrivate: null,
        customId: (0, interfaces_1.getCustomId)(accessory, order),
        description: accessory === null || accessory === void 0 ? void 0 : accessory.description,
        id: accessory === null || accessory === void 0 ? void 0 : accessory.id,
        isRecommended: accessory === null || accessory === void 0 ? void 0 : accessory.isRecommended,
        name: accessory === null || accessory === void 0 ? void 0 : accessory.name,
        price: accessory === null || accessory === void 0 ? void 0 : accessory.price,
        priceExcludingVat: accessory === null || accessory === void 0 ? void 0 : accessory.priceExcludingVat,
        vat: accessory === null || accessory === void 0 ? void 0 : accessory.vat,
        retailerMargin: accessory === null || accessory === void 0 ? void 0 : accessory.margin,
    };
};
exports.mapAccessoryToVehicleAccessory = mapAccessoryToVehicleAccessory;
const mapTireSetToVehicleAccessory = (tireSet, order) => {
    return {
        accessoryType: enums_1.AccessoryType.TYRE,
        calculatedPriceBusiness: null,
        calculatedPricePrivate: null,
        customId: (0, interfaces_1.getCustomId)(tireSet, order),
        description: tireSet === null || tireSet === void 0 ? void 0 : tireSet.description,
        id: tireSet === null || tireSet === void 0 ? void 0 : tireSet.id,
        isRecommended: tireSet === null || tireSet === void 0 ? void 0 : tireSet.isRecommended,
        name: tireSet === null || tireSet === void 0 ? void 0 : tireSet.name,
        price: tireSet === null || tireSet === void 0 ? void 0 : tireSet.additionalPrice,
        priceExcludingVat: tireSet === null || tireSet === void 0 ? void 0 : tireSet.additionalPriceExcludingVat,
        vat: tireSet === null || tireSet === void 0 ? void 0 : tireSet.vat,
        retailerMargin: tireSet === null || tireSet === void 0 ? void 0 : tireSet.retailerMargin,
    };
};
exports.mapTireSetToVehicleAccessory = mapTireSetToVehicleAccessory;
//# sourceMappingURL=accessory.js.map